/** @jsxImportSource @emotion/react */
import estyled from '@signal/theme/emotion'
import {
  drawerZIndexSelector,
  paletteDividerSelector,
  getColorBackgroundSelector,
  getColorPrimarySelector,
  getSpacingSelector,
  getColorTextSelector
} from '@signal/theme/selectors'
import { HEADER_CONTENT_HEIGHT } from '@signal/layouts/constants'
import Brand from '../Brand'
import Typography from '../Typography'

// Styled components for the header
export const HeaderContainer = estyled.header`
  position: sticky;
  top: 0;
  width: 100%;
  height: ${HEADER_CONTENT_HEIGHT};
  background-color: ${props => getColorBackgroundSelector('paper')(props)};
  border-bottom: 1px solid ${props => paletteDividerSelector(props)};
  z-index: ${drawerZIndexSelector};

  @media print {
    display: none;
    position: absolute;
  }
`

export const HeaderContent = estyled.div`
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: space-between;
`

export const LeftSection = estyled.div<{
  $hasLogo?: boolean
}>`
  display: flex;
  flex-direction: ${({ $hasLogo }) => ($hasLogo ? 'row' : 'column')};
  height: 100%;
  align-items: ${({ $hasLogo }) => ($hasLogo ? 'center' : 'flex-start')};
  border-right: 1px solid ${props => paletteDividerSelector(props)};
  gap: ${props => (props.$hasLogo ? `${getSpacingSelector(2)(props)}px` : '0')};
  justify-content: center;
  max-width: ${({ $hasLogo }) => ($hasLogo ? '360px' : '250px')};
  padding: 0 ${getSpacingSelector(2)}px;
`

export const BrandSection = estyled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
`

export const TitleSection = estyled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
`

export const RightSection = estyled.div`
  display: flex;
  align-items: center;
  height: 100%;
  border-left: 1px solid ${props => paletteDividerSelector(props)};
  flex: 0 0 auto;
`

export const ParentAppTitle = estyled(Typography)`
  color: ${getColorPrimarySelector()} !important;
  font-weight: bold !important;
  font-size: 15px !important;
  letter-spacing: 0.2px !important;
  margin: 0 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const AppTitle = estyled(Typography)`
  color: ${getColorTextSelector()} !important;
  font-size: 14px !important;
  margin: 0 !important;
  overflow: hidden;
`

export const HeaderBrand = estyled<{
  height?: number
  width?: number
}>(Brand)``
